var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-page"},[_c('van-loading',{attrs:{"size":"36px","vertical":"","color":"#07C160"}},[_vm._v(" "+_vm._s(_vm.tipText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }